/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Base || (M.Template.Base = {});

M.Template.Base.StatusNotifications = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2014 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<div class="ordersToggle ';
 if (data.length == 1) { 
__p+=' hidden ';
 } 
__p+='">\n  <div class="leftArrow"></div>\n  ORDER <span id="currentOrderNumber">1</span> OF '+
((__t=( data.length ))==null?'':__t)+
'\n  <div class="rightArrow active"></div>\n</div>\n<div class="statusWrapper">\n  <div class="notificationTextArea">\n    ';
 _.each(data, function(order, i) { 
__p+='\n      <div class="singleOrder ';
 if (i != 0) { 
__p+=' hidden ';
 } 
__p+='">\n        ';
 if (order.isDigitalInvitation) { 
__p+='\n          <div class="orderInfo">\n            <a class="orderDetailsLink" href="'+
((__t=( order.CTA_url ))==null?'':__t)+
'">'+
((__t=( order.po_number ))==null?'':__t)+
'</a> |\n            <span class="notificationTextHeavy">'+
((__t=( order.eventLabel ))==null?'':__t)+
'</span>\n          </div>\n          <div class="floatR">\n            <span class="orderStatus">'+
((__t=( order.status_message ))==null?'':__t)+
'</span>\n            ';
 if (order.button_text == 'track your package') { 
__p+='\n              <a class="notificationButton greenButton" href="'+
((__t=( order.CTA_url ))==null?'':__t)+
'" target="_blank">\n                '+
((__t=( order.button_text ))==null?'':__t)+
'\n              </a>\n            ';
 } else { 
__p+='\n              <a class="notificationButton greenButton" href="'+
((__t=( order.CTA_url ))==null?'':__t)+
'">\n                '+
((__t=( order.button_text ))==null?'':__t)+
'\n              </a>\n            ';
 } 
__p+='\n          </div>\n        ';
 } else { 
__p+='\n          <div class="orderInfo">\n            ';
 if (!shouldRenderVisitorVersion) { 
__p+='\n              ORDER #<a class="orderDetailsLink" href="'+
((__t=( M.View.Order.OrderStatus.getDetailsLinkUrl(order) ))==null?'':__t)+
'">'+
((__t=( order.po_number ))==null?'':__t)+
'</a> |\n            ';
 } 
__p+='\n            <span class="notificationTextHeavy">'+
((__t=( M.View.Order.OrderStatus.friendlyTextMapping[order.eventLabel] ))==null?'':__t)+
'</span>\n          </div>\n          <div class="floatR">\n            <span class="orderStatus">'+
((__t=( order.status_message ))==null?'':__t)+
'</span>\n            ';
 if (order.button_text == 'track your package') { 
__p+='\n              <a class="notificationButton greenButton" href="'+
((__t=( M.View.Order.OrderStatus.getButtonClickUrl(order) ))==null?'':__t)+
'" target="_blank">\n                '+
((__t=( order.button_text ))==null?'':__t)+
'\n              </a>\n            ';
 } else { 
__p+='\n              <a class="notificationButton ';
 if (order.button_text != 'review order details') { 
__p+=' greenButton ';
 } 
__p+='" href="'+
((__t=( M.View.Order.OrderStatus.getButtonClickUrl(order) ))==null?'':__t)+
'">\n                '+
((__t=( order.button_text ))==null?'':__t)+
'\n              </a>\n            ';
 } 
__p+='\n          </div>\n        ';
 } 
__p+='\n        </div>\n    ';
 }); 
__p+='\n  </div>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
